/**
 * Operator labels — document correction ops info_requested V0 (minimal panel).
 */

export const DOCUMENT_CORRECTION_OPS_INFO_REQUEST_OPERATOR_LABELS = {
  title: 'Document correction — request more information',
  boundaryCopy:
    'Opens one customer-safe info_requested window on an under_review request. Does not change document truth.',
  loading: 'Loading eligible requests…',
  empty: 'No eligible under_review document correction requests.',
  permissionUnavailable: 'You do not have permission to view this queue.',
  requestInfoUnavailable: 'You do not have permission to request more information.',
  loadFailed: 'Failed to load eligible document correction requests.',
  mutationFailed: 'Failed to open information request.',
  refresh: 'Refresh',
  requestMoreInformation: 'Request more information',
  safeExplanationLabel: 'Customer-safe explanation',
  safeExplanationPlaceholder: 'Explain what information is needed (visible to the customer).',
  cancel: 'Cancel',
  submit: 'Send request',
  success: 'Information request opened.',
} as const;
